module.exports = __webpack_public_path__ + "img/number-thumb-31.b6500406.jpg";